import React, {useState, useEffect} from 'react';
import OrderService from '../../Utils/API/orders';
import { BsFillBoxSeamFill, BsTruck, BsCheckCircleFill, BsXCircleFill } from 'react-icons/bs';
import {TbNotes} from 'react-icons/tb';
import { Portal } from 'react-portal';
import AuthService from '../../AuthService';
import OptimizedImage from '../../Components/OptimizedImage';

const token = AuthService.getToken();

export default function Orders() {
    const [orders, setOrders] = useState([]);
    const [opened, setOpened] = useState(false);
    const [orderInfo, setOrderInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getOrders = async () => {
            const orders = await OrderService.getOrders();
            setOrders(orders);
        }

        getOrders();
    }
    , []);

    function close(){
        setOpened(false);
        setOrder(null);
        setOrderInfo(null);
    }

    async function open(id){
        setOpened(true);
        setOrder(id);
        setLoading(true);
        setOrderInfo(null);

        const order = await OrderService.getOrder(id._id);
        setOrderInfo(order);
        setLoading(false);
    }

    const [order, setOrder] = useState([]);

    const getStatusConfig = (status) => {
        const configs = {
            'Created': { label: 'En preparación', bg: '#fef3c7', color: '#92400e', Icon: TbNotes },
            'Preparing': { label: 'Preparando', bg: '#dbeafe', color: '#1e40af', Icon: BsFillBoxSeamFill },
            'Shipped': { label: 'Enviado', bg: '#d1fae5', color: '#065f46', Icon: BsTruck },
            'Delivered': { label: 'Entregado', bg: '#d1fae5', color: '#065f46', Icon: BsCheckCircleFill },
            'Cancelled': { label: 'Cancelado', bg: '#fee2e2', color: '#991b1b', Icon: BsXCircleFill }
        };
        return configs[status] || configs['Created'];
    };

    return (
        <>
        <div style={{
            marginBottom: '32px'
        }}>
            <h1 style={{
                margin: '0 0 8px 0',
                fontSize: '28px',
                fontWeight: '700',
                color: '#111827',
                fontFamily: 'Inter, sans-serif'
            }}>
                Mis Pedidos
            </h1>
            <p style={{
                margin: 0,
                fontSize: '14px',
                color: '#6b7280',
                fontFamily: 'Inter, sans-serif'
            }}>
                Consulta el estado y detalles de tus pedidos
            </p>
        </div>

        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        }}>
            {orders.length > 0 ? orders.map(order => {
                const statusConfig = getStatusConfig(order.Status);
                const StatusIcon = statusConfig.Icon;

                return (
                    <div
                        key={order._id}
                        onClick={() => open(order)}
                        style={{
                            backgroundColor: '#fff',
                            border: '1px solid #e5e7eb',
                            borderRadius: '12px',
                            padding: '24px',
                            cursor: 'pointer',
                            transition: 'all 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '24px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                            e.currentTarget.style.borderColor = '#028322';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.borderColor = '#e5e7eb';
                        }}
                    >
                        {/* Icono de estado */}
                        <div style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: '12px',
                            backgroundColor: statusConfig.bg,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                        }}>
                            <StatusIcon size={28} color={statusConfig.color} />
                        </div>

                        {/* Información del pedido */}
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            <h3 style={{
                                margin: 0,
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#111827',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Pedido #{order._id.substring(order._id.length - 8).toUpperCase()}
                            </h3>
                            <p style={{
                                margin: 0,
                                fontSize: '14px',
                                color: '#6b7280',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                {new Date(order.CreationDate).toLocaleDateString('es-ES', {
                                    day: 'numeric',
                                    month: 'long',
                                    year: 'numeric'
                                })} • {order.ProductsCount || 0} artículos
                            </p>
                        </div>

                        {/* Badge de estado */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            backgroundColor: statusConfig.bg,
                            color: statusConfig.color,
                            padding: '8px 16px',
                            borderRadius: '8px',
                            fontSize: '14px',
                            fontWeight: '600',
                            fontFamily: 'Inter, sans-serif',
                            whiteSpace: 'nowrap'
                        }}>
                            {statusConfig.label}
                        </div>

                        {/* Total */}
                        <div style={{
                            textAlign: 'right',
                            minWidth: '120px'
                        }}>
                            <p style={{
                                margin: '0 0 4px 0',
                                fontSize: '12px',
                                color: '#6b7280',
                                fontFamily: 'Inter, sans-serif',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}>
                                Total
                            </p>
                            <p style={{
                                margin: 0,
                                fontSize: '24px',
                                fontWeight: '700',
                                color: '#028322',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                {((order.TotalAmount || 0) + (order.ShippingCosts || 0)).toFixed(2)}€
                            </p>
                        </div>

                        {/* Flecha */}
                        <div style={{
                            color: '#9ca3af',
                            fontSize: '24px',
                            flexShrink: 0
                        }}>
                            →
                        </div>
                    </div>
                )
            }) : (
                <div style={{
                    textAlign: 'center',
                    padding: '60px 20px',
                    backgroundColor: '#f9fafb',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb'
                }}>
                    <p style={{
                        margin: '0 0 8px 0',
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#111827',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        No tienes pedidos
                    </p>
                    <p style={{
                        margin: 0,
                        fontSize: '14px',
                        color: '#6b7280',
                        fontFamily: 'Inter, sans-serif'
                    }}>
                        Cuando realices un pedido, aparecerá aquí
                    </p>
                </div>
            )}
        </div>
        {
            opened ? <Portal>
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '20px'
                    }}
                    onClick={close}
                >
                    {loading ? (
                        <div style={{
                            backgroundColor: '#fff',
                            borderRadius: '16px',
                            padding: '60px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '20px',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                        >
                            <div style={{
                                width: '48px',
                                height: '48px',
                                border: '4px solid #e5e7eb',
                                borderTop: '4px solid #028322',
                                borderRadius: '50%',
                                animation: 'spin 0.8s linear infinite'
                            }} />
                            <style>
                                {`
                                    @keyframes spin {
                                        0% { transform: rotate(0deg); }
                                        100% { transform: rotate(360deg); }
                                    }
                                `}
                            </style>
                            <p style={{
                                margin: 0,
                                fontSize: '14px',
                                color: '#6b7280',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Cargando pedido...
                            </p>
                        </div>
                    ) : (
                        <div
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: '16px',
                                maxWidth: '900px',
                                width: '100%',
                                maxHeight: '90vh',
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                                boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                        {/* Header */}
                        <div style={{
                            padding: '32px',
                            borderBottom: '1px solid #e5e7eb',
                            backgroundColor: '#fafafa'
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px' }}>
                                <div>
                                    <h2 style={{
                                        margin: 0,
                                        fontSize: '24px',
                                        fontWeight: '700',
                                        color: '#111827',
                                        fontFamily: 'Inter, sans-serif',
                                        marginBottom: '8px'
                                    }}>
                                        Pedido #{order._id?.substring(order._id.length - 8).toUpperCase()}
                                    </h2>
                                    <p style={{
                                        margin: 0,
                                        fontSize: '14px',
                                        color: '#6b7280',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Realizado el {new Date(orderInfo?.CreationDate).toLocaleDateString('es-ES', {
                                            day: 'numeric',
                                            month: 'long',
                                            year: 'numeric'
                                        })}
                                    </p>
                                </div>
                                <button
                                    onClick={close}
                                    style={{
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '8px',
                                        border: 'none',
                                        backgroundColor: '#fff',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px',
                                        color: '#6b7280',
                                        transition: 'all 0.2s'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                >
                                    ×
                                </button>
                            </div>

                            {/* Progress Steps */}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
                                {/* Progress line */}
                                <div style={{
                                    position: 'absolute',
                                    top: '20px',
                                    left: '24px',
                                    right: '24px',
                                    height: '2px',
                                    backgroundColor: '#e5e7eb',
                                    zIndex: 0
                                }}>
                                    <div style={{
                                        height: '100%',
                                        backgroundColor: '#028322',
                                        width: orderInfo?.Status === 'Created' ? '0%' :
                                               orderInfo?.Status === 'Preparing' ? '50%' : '100%',
                                        transition: 'width 0.3s ease'
                                    }} />
                                </div>

                                {/* Step 1: Created */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1, flex: 1 }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor: '#028322',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '8px'
                                    }}>
                                        <TbNotes size={20} color="#fff" />
                                    </div>
                                    <span style={{
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        color: '#028322',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Recibido
                                    </span>
                                </div>

                                {/* Step 2: Preparing */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1, flex: 1 }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor: orderInfo?.Status === 'Preparing' || orderInfo?.Status === 'Shipped' || orderInfo?.Status === 'Delivered' ? '#028322' : '#e5e7eb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '8px',
                                        transition: 'all 0.3s'
                                    }}>
                                        <BsFillBoxSeamFill size={20} color={orderInfo?.Status === 'Preparing' || orderInfo?.Status === 'Shipped' || orderInfo?.Status === 'Delivered' ? '#fff' : '#9ca3af'} />
                                    </div>
                                    <span style={{
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        color: orderInfo?.Status === 'Preparing' || orderInfo?.Status === 'Shipped' || orderInfo?.Status === 'Delivered' ? '#028322' : '#9ca3af',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Preparando
                                    </span>
                                </div>

                                {/* Step 3: Shipped */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: 1, flex: 1 }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        backgroundColor: orderInfo?.Status === 'Shipped' || orderInfo?.Status === 'Delivered' ? '#028322' : '#e5e7eb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '8px',
                                        transition: 'all 0.3s'
                                    }}>
                                        <BsTruck size={20} color={orderInfo?.Status === 'Shipped' || orderInfo?.Status === 'Delivered' ? '#fff' : '#9ca3af'} />
                                    </div>
                                    <span style={{
                                        fontSize: '12px',
                                        fontWeight: '500',
                                        color: orderInfo?.Status === 'Shipped' || orderInfo?.Status === 'Delivered' ? '#028322' : '#9ca3af',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Enviado
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Content */}
                        <div style={{
                            flex: 1,
                            overflowY: 'auto',
                            padding: '32px'
                        }}>
                            {/* Productos */}
                            <h3 style={{
                                margin: '0 0 20px 0',
                                fontSize: '18px',
                                fontWeight: '600',
                                color: '#111827',
                                fontFamily: 'Inter, sans-serif'
                            }}>
                                Productos ({orderInfo?.Products?.length || 0})
                            </h3>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
                                {orderInfo?.Products?.map((product, index) => {
                                    const productData = product.product || product.productSnapshot;
                                    if (!productData) return null;

                                    const isDeleted = !product.product && product.productSnapshot;

                                    return (
                                        <div
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                gap: '16px',
                                                padding: '16px',
                                                backgroundColor: isDeleted ? '#fef2f2' : '#f9fafb',
                                                borderRadius: '12px',
                                                border: isDeleted ? '1px solid #fecaca' : '1px solid #f3f4f6',
                                                alignItems: 'center',
                                                transition: 'all 0.2s'
                                            }}
                                        >
                                            <OptimizedImage
                                                src={productData.images && productData.images[0] ? productData.images[0] : 'https://cdn.beeapp.es/distribucionesrb/NoImage.png'}
                                                alt={productData.name || 'Producto'}
                                                width={80}
                                                height={80}
                                                fit="contain"
                                                quality={75}
                                                style={{
                                                    width: '80px',
                                                    height: '80px',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                    flexShrink: 0,
                                                    opacity: isDeleted ? 0.7 : 1
                                                }}
                                                onError={(e) => {
                                                    e.target.src = 'https://cdn.beeapp.es/distribucionesrb/NoImage.png';
                                                }}
                                            />
                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                <h4 style={{
                                                    margin: '0 0 4px 0',
                                                    fontSize: '15px',
                                                    fontWeight: '600',
                                                    color: isDeleted ? '#991b1b' : '#111827',
                                                    fontFamily: 'Inter, sans-serif',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {productData.name || 'Producto descatalogado'}
                                                </h4>
                                                {isDeleted && (
                                                    <span style={{
                                                        display: 'inline-block',
                                                        fontSize: '11px',
                                                        fontWeight: '500',
                                                        color: '#dc2626',
                                                        backgroundColor: '#fee2e2',
                                                        padding: '2px 8px',
                                                        borderRadius: '4px',
                                                        marginBottom: '4px'
                                                    }}>
                                                        Producto descatalogado
                                                    </span>
                                                )}
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: '13px',
                                                    color: '#6b7280',
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    Ref: {productData.reference || 'N/A'}
                                                </p>
                                            </div>
                                            <div style={{ textAlign: 'right', flexShrink: 0 }}>
                                                <p style={{
                                                    margin: '0 0 4px 0',
                                                    fontSize: '15px',
                                                    fontWeight: '600',
                                                    color: '#111827',
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    {product.quantity} uds
                                                </p>
                                                <p style={{
                                                    margin: 0,
                                                    fontSize: '14px',
                                                    color: '#6b7280',
                                                    fontFamily: 'Inter, sans-serif'
                                                }}>
                                                    {product.price.toFixed(2)}€
                                                </p>
                                            </div>
                                        </div>
                                    );
                                }).filter(item => item !== null)}
                            </div>

                            {/* Dirección de envío */}
                            {orderInfo?.Address && (
                                <div style={{ marginBottom: '32px' }}>
                                    <h3 style={{
                                        margin: '0 0 16px 0',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        color: '#111827',
                                        fontFamily: 'Inter, sans-serif'
                                    }}>
                                        Dirección de envío
                                    </h3>
                                    <div style={{
                                        padding: '16px',
                                        backgroundColor: '#f9fafb',
                                        borderRadius: '12px',
                                        border: '1px solid #f3f4f6'
                                    }}>
                                        <p style={{
                                            margin: '0 0 4px 0',
                                            fontSize: '14px',
                                            color: '#111827',
                                            fontFamily: 'Inter, sans-serif',
                                            fontWeight: '500'
                                        }}>
                                            {orderInfo.Address[0]?.Address}
                                        </p>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '14px',
                                            color: '#6b7280',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {orderInfo.Address[0]?.City}, {orderInfo.Address[0]?.ZIP}
                                        </p>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '14px',
                                            color: '#6b7280',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {orderInfo.Address[0]?.Country}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {/* Resumen */}
                            <div style={{
                                padding: '24px',
                                backgroundColor: '#f9fafb',
                                borderRadius: '12px',
                                border: '1px solid #f3f4f6'
                            }}>
                                <h3 style={{
                                    margin: '0 0 16px 0',
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: '#111827',
                                    fontFamily: 'Inter, sans-serif'
                                }}>
                                    Resumen
                                </h3>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{
                                            fontSize: '14px',
                                            color: '#6b7280',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            Subtotal
                                        </span>
                                        <span style={{
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#111827',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {orderInfo?.TotalAmount?.toFixed(2)}€
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <span style={{
                                            fontSize: '14px',
                                            color: '#6b7280',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            Envío
                                        </span>
                                        <span style={{
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#111827',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {orderInfo?.ShippingCosts === 0 ? 'Gratis' : `${orderInfo?.ShippingCosts?.toFixed(2)}€`}
                                        </span>
                                    </div>
                                    <div style={{
                                        borderTop: '1px solid #e5e7eb',
                                        marginTop: '8px',
                                        paddingTop: '12px',
                                        display: 'flex',
                                        justifyContent: 'space-between'
                                    }}>
                                        <span style={{
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#111827',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            Total
                                        </span>
                                        <span style={{
                                            fontSize: '18px',
                                            fontWeight: '700',
                                            color: '#028322',
                                            fontFamily: 'Inter, sans-serif'
                                        }}>
                                            {((orderInfo?.TotalAmount || 0) + (orderInfo?.ShippingCosts || 0)).toFixed(2)}€
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '24px 32px',
                            borderTop: '1px solid #e5e7eb',
                            backgroundColor: '#fafafa'
                        }}>
                            <button
                                onClick={() => {
                                    window.open('https://api.rb.beeapp.es/pdfViewer/'+token+'/'+order._id+'/new', '_blank', 'width=600,height=800,scrollbars=no,resizable=no,toolbar=no,location=no,menubar=no,status=no');
                                }}
                                style={{
                                    width: '100%',
                                    padding: '14px',
                                    backgroundColor: '#028322',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontSize: '15px',
                                    fontWeight: '600',
                                    fontFamily: 'Inter, sans-serif',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#026a1b'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#028322'}
                            >
                                Ver factura
                            </button>
                        </div>
                    </div>
                    )}
                </div>
            </Portal> : null
        }
       
        </>
    )
}